import { render, staticRenderFns } from "./ApprovalRequirement.vue?vue&type=template&id=acb94170"
import script from "./ApprovalRequirement.vue?vue&type=script&lang=js"
export * from "./ApprovalRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports